import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "../../components/AuthenticationGuard/AuthenticationGuard";
import CompanyManagement from "@/modules/hub/features/CompanyManagement/components/CompanyList/CompanyList";
import TestCompanyBuilderPage from "@/modules/administration/features/TestCompanyBuilder/components/TestCompanyBuilderPage/TestCompanyBuilderPage";
import PermissionGuard from "../../components/PermissionGuard/PermissionGuard";
import CreateCompany from "@/modules/hub/features/CompanyManagement/components/CreateCompany/CreateCompany";
import EditCompany from "@/modules/hub/features/CompanyManagement/components/EditCompany/EditCompany";
import CreateResource from "@/modules/hub/features/ResourceManagement/components/CreateResource/CreateResource";
import EditResource from "@/modules/hub/features/ResourceManagement/components/EditResource/EditResource";
import ResourceList from "@/modules/hub/features/ResourceManagement/components/ResourceList/ResourceList";
import CourseList from "@/modules/learningCenter/features/CourseManagement/components/CourseList/CourseList";
import CreateCourse from "@/modules/learningCenter/features/CourseManagement/components/CreateCourse/CreateCourse";
import EditCourse from "@/modules/learningCenter/features/CourseManagement/components/EditCourse/EditCourse";
import LibraryModuleList from "@/modules/learningCenter/features/ModuleLibrary/components/LibraryModuleList/LibraryModuleList";
import CreateLibraryModule from "@/modules/learningCenter/features/ModuleLibrary/components/CreateLibraryModule/CreateLibraryModule";
import EditLibraryModule from "@/modules/learningCenter/features/ModuleLibrary/components/EditLibraryModule/EditLibraryModule";
import FileManagementPage from "@/modules/hub/features/FileManagement/components/FileManagementPage/FileManagementPage";
import ResourceCategoryList from "@/modules/hub/features/ResourceCategoryManagement/components/ResourceCategoryList/ResourceCategoryList";
import ResourceTagList from "@/modules/hub/features/ResourceTagManagement/components/ResourceTagList/ResourceTagList";
import ImageRemediationPage from "@/modules/administration/features/ImageRemediation/components/ImageRemediationPage/ImageRemediationPage";
import EventCategoryList from "@/modules/eventRegistration/features/EventCategoryManagement/components/EventCategoryList/EventCategoryList";
import EventList from "@/modules/eventRegistration/features/EventManagement/components/EventList/EventList";
import CreateEvent from "@/modules/eventRegistration/features/EventManagement/components/CreateEvent/CreateEvent";
import EditEvent from "@/modules/eventRegistration/features/EventManagement/components/EditEvent/EditEvent";
import EventSessionList from "@/modules/eventRegistration/features/EventSessionManagement/components/EventSessionList/EventSessionList";
import EventInstructorList from "@/modules/eventRegistration/features/EventInstructorManagement/components/EventInstructorList/EventInstructorList";
import VoucherList from "@/modules/eventRegistration/features/EventVoucherManagement/components/VoucherList/VoucherList";
import CreateVoucher from "@/modules/eventRegistration/features/EventVoucherManagement/components/CreateVoucher/CreateVoucher";
import BulkCreateVoucher from "@/modules/eventRegistration/features/EventVoucherManagement/components/BulkCreateVoucher/BulkCreateVoucher";
import EditVoucher from "@/modules/eventRegistration/features/EventVoucherManagement/components/UpdateVoucher/UpdateVoucher";
import VenueList from "@/modules/eventRegistration/features/EventVenueManagement/components/VenueList/VenueList";
import CreateVenue from "@/modules/eventRegistration/features/EventVenueManagement/components/CreateVenue/CreateVenue";
import EditVenue from "@/modules/eventRegistration/features/EventVenueManagement/components/EditVenue/EditVenue";
import DiscountList from "@/modules/eventRegistration/features/EventDiscountManagement/components/DiscountList/DiscountList";
import CreateDiscount from "@/modules/eventRegistration/features/EventDiscountManagement/components/CreateDiscount/CreateDiscount";
import EditDiscount from "@/modules/eventRegistration/features/EventDiscountManagement/components/EditDiscount/EditDiscount";
import Waitlist from "@/modules/eventRegistration/features/EventWaitlist/components/Waitlist/Waitlist";
import { Navigate } from "react-router-dom";
import EmailTemplatesList from "@/modules/emailManagement/features/EmailTemplateManagement/components/EmailTemplateList/EmailTemplatesList";
import CreateEmailTemplate from "@/modules/emailManagement/features/EmailTemplateManagement/components/CreateEmailTemplate/CreateEmailTemplate";
import EditEmailTemplate from "@/modules/emailManagement/features/EmailTemplateManagement/components/EditEmailTemplate/EditEmailTemplate";
import EmailCampaignList from "@/modules/emailManagement/features/EmailCampaignManagement/components/EmailCampaignList/EmailCampaignList";
import CreateEmailCampaign from "@/modules/emailManagement/features/EmailCampaignManagement/components/CreateEmailCampaign/CreateEmailCampaign";
import EmailTemplateCategoryList from "@/modules/emailManagement/features/EmailTemplateCategoryManagement/components/EmailTemplateCategoryList/EmailTemplateCategoryList";
import SpecialtyManagementPage from "@/modules/administration/features/EmployeeDirectoryManagement/components/Specialty/SpecialtyManagementPage/SpecialtyManagementPage";
import TeamManagementPage from "@/modules/administration/features/EmployeeDirectoryManagement/components/Team/TeamManagementPage/TeamManagementPage";
import EmployeeProfileManagementPage from "../../modules/administration/features/EmployeeDirectoryManagement/components/Profile/EmployeeProfileManagementPage/EmployeeProfileManagementPage";
import CreateEmployeeProfilePage from "../../modules/administration/features/EmployeeDirectoryManagement/components/Profile/CreateEmployeeProfilePage/CreateEmployeeProfilePage";
import EditEmployeeProfilePage from "../../modules/administration/features/EmployeeDirectoryManagement/components/Profile/EditEmployeeProfilePage/EditEmployeeProfilePage";
import EmailEventLogList from "@/modules/emailManagement/features/EmailEventLogsManagement/component/EmailEventLogList/EmailEventLogList";
import UpdateEmailCampaign from "@/modules/emailManagement/features/EmailCampaignManagement/components/UpdateEmailCampaign/UpdateEmailCampaign";
import AdminUserList from "@/modules/administration/features/UserManagement/components/AdminUserList/AdminUserList";
import AdminEditUser from "@/modules/administration/features/UserManagement/components/AdminEditUser/AdminEditUser";
import AdminCreateUser from "@/modules/administration/features/UserManagement/components/AdminCreateUser/AdminCreateUser";
import BusinessRolesList from "@/modules/administration/features/BusinessRoleManagement/components/BusinessRolesList/BusinessRolesList";
import StageList from "@/modules/administration/features/StageManagement/components/StageList/StageList";
import CatalogProductList from "@/modules/administration/features/ProductCatalogManagement/components/CatalogProductList/CatalogProductList";
import CatalogProductCreatePage from "@/modules/administration/features/ProductCatalogManagement/components/CatalogProductCreatePage/CatalogProductCreatePage";
import CatalogProductEditPage from "@/modules/administration/features/ProductCatalogManagement/components/CatalogProductEditPage/CatalogProductEditPage";
import CatalogCategoryList from "@/modules/administration/features/ProductCatalogManagement/components/CatalogCategoryList/CatalogCategoryList";
import ProcessWheelList from "@/modules/administration/features/ProcessWheelManagement/components/ProcessWheelList/ProcessWheelList";
import ReportsPage from "@/modules/administration/features/Reports/components/ReportsPage/ReportsPage";
import EventNotificationsPage from "@/modules/administration/features/Events/Notifications/components/EventNotificationsPage/EventNotificationsPage";
import EditEventNotification from "@/modules/administration/features/Events/Notifications/components/EditEventNotification/EditEventNotification";
import RegistrationsReportPage from "@/modules/administration/features/Events/Reports/components/RegistrationsReportPage/RegistrationsReportPage";
import RosterManagementReportPage from "@/modules/administration/features/Events/Reports/components/RosterManagementReportPage/RosterManagementReportPage";
import TrainingHistoryReportPage from "@/modules/administration/features/Events/Reports/components/TrainingHistoryReportPage/TrainingHistoryReportPage";
import VouchersReportPage from "@/modules/administration/features/Events/Reports/components/VouchersReportPage/VouchersReportPage";
import TransactionHistoryReportPage from "@/modules/administration/features/Events/Reports/components/TransactionHistoryReportPage/TransactionHistoryReportPage";
import SessionsReportPage from "@/modules/administration/features/Events/Reports/components/SessionsReportPage/SessionsReportPage";
import ProductsHistoryReportPage from "@/modules/administration/features/Events/Reports/components/ProductsHistoryReportPage/ProductsHistoryReportPage";
import { SalesPortalPage } from "@/modules/administration/features/SalesPortal/components/SalesPortalPage/SalesPortalPage";
import DataConnectorAdoptionDashboard from "@/modules/administration/features/DataConnectorAdoption/components/DataConnectorAdoptionDashboard/DataConnectorAdoptionDashboard";
import CompaniesList from "@/modules/administration/features/Diagnostics/components/CompaniesList/CompaniesList";
import CompanyDetail from "@/modules/administration/features/Diagnostics/components/CompanyDetail/CompanyDetail";
import ReviewScreen from "@/modules/administration/features/Diagnostics/components/ReviewScreen/ReviewScreen";
import MonthlyReport from "@/modules/scoreboard/features/MonthlyReport/MonthlyReport";
import TradeLeaderboards from "@/modules/scoreboard/features/TradeLeaderboards/TradeLeaderboards";

// Create stable component reference
const AdminMainLayout = () => <MainLayout section="admin" />;

/**
 * AdminRoutes
 *
 * Wraps the /admin area in our Auth0-based authentication guard.
 * Then for single-route permission checks, we wrap each route element
 * with <PermissionGuard>.
 */
const AdminRoutes = (
  <Route
    element={<AuthenticationGuard component={AdminMainLayout} />}
    path="/admin"
  >
    {/* List / Index page */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-companies"]}>
          <CompanyManagement />
        </PermissionGuard>
      }
      index
    />

    {/* Company Management */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-companies"]}>
          <CompanyManagement />
        </PermissionGuard>
      }
      path="companies"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-companies"]}>
          <CreateCompany />
        </PermissionGuard>
      }
      path="companies/create"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-companies"]}>
          <EditCompany />
        </PermissionGuard>
      }
      path="companies/:uuid/edit"
    />

    {/* Admin User Management */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-users"]}>
          <AdminUserList />
        </PermissionGuard>
      }
      path="users"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-users"]}>
          <AdminCreateUser />
        </PermissionGuard>
      }
      path="users/create"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-users"]}>
          <AdminEditUser />
        </PermissionGuard>
      }
      path="users/:uuid/edit"
    />

    {/* Business Roles & Permissions */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-users"]}>
          <BusinessRolesList />
        </PermissionGuard>
      }
      path="business-roles"
    />

    {/* Product Catalog */}
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-product-catalog"]}
        >
          <CatalogProductList />
        </PermissionGuard>
      }
      path="product-catalog/products"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-product-catalog"]}
        >
          <CatalogProductCreatePage />
        </PermissionGuard>
      }
      path="product-catalog/products/new"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-product-catalog"]}
        >
          <CatalogProductEditPage />
        </PermissionGuard>
      }
      path="product-catalog/products/:id/edit"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-product-catalog"]}
        >
          <CatalogCategoryList />
        </PermissionGuard>
      }
      path="product-catalog/categories"
    />

    {/* Stages */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-stages"]}>
          <StageList />
        </PermissionGuard>
      }
      path="stages"
    />

    {/* Reports */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-reports"]}>
          <ReportsPage />
        </PermissionGuard>
      }
      path="reports"
    />

    {/* Resource Management */}
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <CreateResource />
        </PermissionGuard>
      }
      path="resources/new"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <EditResource />
        </PermissionGuard>
      }
      path="resources/:uuid/edit"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <ResourceList />
        </PermissionGuard>
      }
      path="resources"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-learning-center"]}
        >
          <CreateCourse />
        </PermissionGuard>
      }
      path="learning-center/courses/new"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-learning-center"]}
        >
          <EditCourse />
        </PermissionGuard>
      }
      path="learning-center/courses/:uuid/edit"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-learning-center"]}
        >
          <CourseList />
        </PermissionGuard>
      }
      path="learning-center/courses"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-learning-center"]}
        >
          <CreateLibraryModule />
        </PermissionGuard>
      }
      path="learning-center/module-library/new"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-learning-center"]}
        >
          <EditLibraryModule />
        </PermissionGuard>
      }
      path="learning-center/module-library/:uuid/edit"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-learning-center"]}
        >
          <LibraryModuleList />
        </PermissionGuard>
      }
      path="learning-center/module-library"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <FileManagementPage />
        </PermissionGuard>
      }
      path="file-manager"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <ResourceCategoryList />
        </PermissionGuard>
      }
      path="resource-categories"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <ResourceTagList />
        </PermissionGuard>
      }
      path="resource-tags"
    />

    {/* Process Wheel */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-process-wheel"]}>
          <ProcessWheelList />
        </PermissionGuard>
      }
      path="process-wheels"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-resource-library"]}
        >
          <ImageRemediationPage />
        </PermissionGuard>
      }
      path="image-remediation"
    />

    {/* Event Management */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EventList />
        </PermissionGuard>
      }
      path="events"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EventSessionList />
        </PermissionGuard>
      }
      path="events/:uuid/sessions"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <Waitlist />
        </PermissionGuard>
      }
      path="events/:eventUuid/sessions/:uuid/waitlist"
    />

    <Route
      element={<Navigate replace to="../waitlist" />}
      path="events/:eventUuid/sessions/:uuid/transactions"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <CreateEvent />
        </PermissionGuard>
      }
      path="events/new"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EditEvent />
        </PermissionGuard>
      }
      path="events/:uuid/edit"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EventCategoryList />
        </PermissionGuard>
      }
      path="event-categories"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EventInstructorList />
        </PermissionGuard>
      }
      path="event-instructors"
    />

    {/* Vouchers */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <VoucherList />
        </PermissionGuard>
      }
      path="vouchers"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <CreateVoucher />
        </PermissionGuard>
      }
      path="voucher/new"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <BulkCreateVoucher />
        </PermissionGuard>
      }
      path="voucher/bulk-create"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EditVoucher />
        </PermissionGuard>
      }
      path="voucher/:voucherId/edit"
    />

    {/* Venues */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <VenueList />
        </PermissionGuard>
      }
      path="venues"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <CreateVenue />
        </PermissionGuard>
      }
      path="venue/new"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EditVenue />
        </PermissionGuard>
      }
      path="venue/:venueId/edit"
    />

    {/* Discounts */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <DiscountList />
        </PermissionGuard>
      }
      path="discounts"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <CreateDiscount />
        </PermissionGuard>
      }
      path="discount/new"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <EditDiscount />
        </PermissionGuard>
      }
      path="discount/:discountId/edit"
    />

    {/* Event Notifications */}
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-event-notifications"]}
        >
          <EventNotificationsPage />
        </PermissionGuard>
      }
      path="event-notifications"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-event-notifications"]}
        >
          <EditEventNotification />
        </PermissionGuard>
      }
      path="event-notifications/:id/edit"
    />

    {/* Event Reports */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <RegistrationsReportPage />
        </PermissionGuard>
      }
      path="events/reports/registrations"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <RosterManagementReportPage />
        </PermissionGuard>
      }
      path="events/reports/roster-management"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <TrainingHistoryReportPage />
        </PermissionGuard>
      }
      path="events/reports/training-history"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <VouchersReportPage />
        </PermissionGuard>
      }
      path="events/reports/vouchers"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <TransactionHistoryReportPage />
        </PermissionGuard>
      }
      path="events/reports/transaction-history"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <SessionsReportPage />
        </PermissionGuard>
      }
      path="events/reports/sessions"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-events"]}>
          <ProductsHistoryReportPage />
        </PermissionGuard>
      }
      path="events/reports/products-history"
    />

    {/* Sales Portal */}
    <Route
      element={<Navigate replace to="sales-portal/opportunities" />}
      path="sales-portal"
    />
    <Route
      element={
        <PermissionGuard requiredPermissions={["sales-portal"]}>
          <SalesPortalPage />
        </PermissionGuard>
      }
      path="sales-portal/opportunities"
    />

    {/* Data Connector Adoption */}
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-data-connector-adoption"]}
        >
          <DataConnectorAdoptionDashboard />
        </PermissionGuard>
      }
      path="data-connector-adoption"
    />

    {/* Stage Diagnostics. `attempts/:attemptId` is declared before
        `:companyId` — React Router v6 ranks static segments above dynamic
        ones so it is safe either way, but the order says what is intended. */}
    <Route
      element={
        <PermissionGuard
          requireCertainPathCompany
          requiredPermissions={["stage-diagnostics"]}
        >
          <CompaniesList />
        </PermissionGuard>
      }
      path="diagnostics"
    />
    <Route
      element={
        <PermissionGuard
          requireCertainPathCompany
          requiredPermissions={["stage-diagnostics"]}
        >
          <ReviewScreen />
        </PermissionGuard>
      }
      path="diagnostics/attempts/:attemptId"
    />
    <Route
      element={
        <PermissionGuard
          requireCertainPathCompany
          requiredPermissions={["stage-diagnostics"]}
        >
          <CompanyDetail />
        </PermissionGuard>
      }
      path="diagnostics/:companyId"
    />

    {/* Email Management */}
    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <EmailTemplatesList />
        </PermissionGuard>
      }
      path="email-templates"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <CreateEmailTemplate />
        </PermissionGuard>
      }
      path="email-template/new"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <EditEmailTemplate />
        </PermissionGuard>
      }
      path="email-templates/:emailTemplateId/edit"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <EmailTemplateCategoryList />
        </PermissionGuard>
      }
      path="email-template-categories"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["employee-directory-management"]}
        >
          <SpecialtyManagementPage />
        </PermissionGuard>
      }
      path="employee-directory/specialties"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["employee-directory-management"]}
        >
          <TeamManagementPage />
        </PermissionGuard>
      }
      path="employee-directory/teams"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["employee-directory-management"]}
        >
          <EmployeeProfileManagementPage />
        </PermissionGuard>
      }
      path="employee-directory/profiles"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["employee-directory-management"]}
        >
          <CreateEmployeeProfilePage />
        </PermissionGuard>
      }
      path="employee-directory/profiles/create"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["employee-directory-management"]}
        >
          <EditEmployeeProfilePage />
        </PermissionGuard>
      }
      path="employee-directory/profiles/:uuid/edit"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <EmailCampaignList />
        </PermissionGuard>
      }
      path="email-campaigns"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <CreateEmailCampaign />
        </PermissionGuard>
      }
      path="email-campaign/new"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <EmailEventLogList />
        </PermissionGuard>
      }
      path="email/activity"
    />

    <Route
      element={
        <PermissionGuard
          requiredPermissions={["administration-email-management"]}
        >
          <UpdateEmailCampaign />
        </PermissionGuard>
      }
      path="email-campaign/:emailCampaignId/edit"
    />

    {/* Test Company Builder — sandbox-only tool for spinning up SF + HubPlus */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["administration-companies"]}>
          <TestCompanyBuilderPage />
        </PermissionGuard>
      }
      path="test-company-builder"
    />

    {/* Scoreboard — Monthly Report + Trade Leaderboards (CertainPath only).
        NOTE: the permission slug `admin-monthly-scoreboard` is INTENTIONAL — it
        is NOT a typo of the `administration-*` convention used by sibling admin
        permissions. It must stay byte-identical with the backend Voter and the
        permission migration (Auth0-safe, already deployed); do not "correct" it. */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["admin-monthly-scoreboard"]}>
          <MonthlyReport />
        </PermissionGuard>
      }
      path="scoreboard/monthly-report"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["admin-monthly-scoreboard"]}>
          <TradeLeaderboards />
        </PermissionGuard>
      }
      path="scoreboard/leaderboards"
    />
  </Route>
);

export default AdminRoutes;
